import { RiCheckDoubleFill } from "react-icons/ri";
import { Button, buttonState } from "@/components/ui";
import { motion } from "motion/react";
import { svgLinks } from "../../../../public/assets/assetLinks";

type featureType = {
  name: string;
  icon?: any;
};

export type pricingCardType = {
  title: string;
  text: string;
  price: number;
  feature: featureType[];
  cardStyle?: string;
  iconStyle?: string;
  buttonLabel: string;
  buttonState: buttonState;
};

export const PricingCard = ({
  title,
  text,
  cardStyle,
  iconStyle,
  price,
  buttonLabel,
  buttonState = "tertiary",
  feature,
}: pricingCardType) => {
  return (
    <motion.div
      whileHover={{ scale: 1.1 }}
      className={`border border-[#FFFFFF24] flex flex-grow flex-col max-w-sm h-[600px] lg:h-[664px] p-5 rounded-3xl ${cardStyle}`}
    >
      <div className="flex-1">
        <div className="h-[180px] lg:h-[256px]">
          <div
            className={`border rounded-full size-8 mb-5 justify-center items-center flex bg-[#0B0C0E] border-[#FFFFFF24] ${iconStyle}`}
          >
            <img src={svgLinks.lightning} className="size-5" loading="lazy" />
          </div>
          <div className="space-y-3">
            <h6>{title}</h6>
            <h1 className="text-tertiary line-clamp-2">{text}</h1>
            <h4 className="text-tertiary pt-3 lg:pt-10">
              $<span className=" text-white">{price}</span>
              <span className=" text-sm">/ per month</span>
            </h4>
          </div>
        </div>
        <hr className="border-t border-[#FFFFFF24] my-6" />
        <div className="space-y-3 lg:space-y-5">
          {feature.map((item) => (
            <div className="flex flex-row items-center  gap-3">
              <div
                className={`border rounded-full size-8 items-center flex justify-center ${iconStyle} border-[#FFFFFF24]`}
              >
                {item.icon ? item.icon : <RiCheckDoubleFill color="white" />}
              </div>
              <h1 className="text-tertiary">{item.name}</h1>
            </div>
          ))}
        </div>
      </div>
      <hr className="border-t border-[#FFFFFF24] my-4" />
      <div className="justify-end bottom-0 flex">
        <Button label={buttonLabel} className="w-full" state={buttonState} />
      </div>
    </motion.div>
  );
};
